/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
import React, { useRef, useState, useEffect } from "react";

import { IoIosArrowDown } from "react-icons/io";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import {
  Avatar,
  Box,
  Button,
  FabButton,
  Flex,
  Typography,
} from "../../ppui";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import {
  HeaderContainer,
  HeaderLayout,
  HeaderMenu,
  HeaderUserItem,
  HeaderUserList,
} from "./style";

import { TbPower, } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import { useOnClickOutside } from "../../ppui/outside.click";
import { shortFormName } from "../../utils/common";
import { Brand, } from "../menu/style";
import Logo from "../../assets/svgs/logo";
import { SiOnlyoffice } from "react-icons/si";

export default function Header({ toggleNav, isNavActive, fullWidth }) {
  const { setUser, orgDetails, authInfo, signinEmail } = useAuthContext();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [isMenuVisible, setMenuVisible] = useState(false);
  const menuItems = [
    // {
    //   icon: <TbUser />,
    //   primaryText: "Profile",
    //   path: "/employee-details/employee-info",
    // },
    // {
    //   icon: <TbSettings />,
    //   primaryText: "Settings",
    //   path: "/employee-details/pay-and-benefits-info",
    // },
    // {
    //   icon: <TbHelp />,
    //   primaryText: "Help & Support",
    //   path: "/employee-details/holiday-info",
    // },
    {
      icon: <TbPower />,
      primaryText: "Logout",

      onClick: () => {
        localStorage.removeItem("hrms_token");
        localStorage.removeItem("hrms_admin_token");
        setUser(null);
        if (window.location.pathname.startsWith("/admin")) {
          navigate("/admin-login");
        } else {
          navigate("/");
        }
        window.location.reload();
      },
    },
  ];




  const toggleMenu = () => {
    setMenuVisible((prev) => !prev);
  };
  useOnClickOutside(dropdownRef, () => {
    setMenuVisible(false);
  });
  const {
    orgDetails: fromGblobalorgDetails,

  } = useAuthContext();


  useEffect(() => { }, [fromGblobalorgDetails?.org_name]);
  return (
    <>
      <HeaderLayout id="header" className={isNavActive ? "navCollapse" : ""} fullWidth={fullWidth}>
        <HeaderContainer>
          <Flex gap={10}>
            {fullWidth ?
              <Brand to={"/"}>
                {fromGblobalorgDetails?.org_name ?
                  (
                    <>
                      {fromGblobalorgDetails?.logo ?
                        <img src={`${fromGblobalorgDetails?.path + fromGblobalorgDetails?.logo}`} />
                        :
                        <SiOnlyoffice />
                      }
                    </>
                  )
                  :
                  <Logo />
                }
              </Brand>
              :
              <FabButton
                icon={
                  isNavActive ? (
                    <MdKeyboardDoubleArrowRight />
                  ) : (
                    <MdKeyboardDoubleArrowLeft />
                  )
                }
                variant="outlined"
                color="primary"
                shape="box"
                onClick={toggleNav}
                size="sm"
              />
            }
            <Typography
              mb={"0"}
              variant="h5"
              sx={{ textTransform: "uppercase" }}
              color="primary"
            >
                {orgDetails?.org_name}
            </Typography>
          </Flex>
          <List size={"md"}>
            <ListItem onClick={toggleMenu}>
              <Avatar shape="circle" initials={shortFormName(`${authInfo?.[0]?.first_name} ${authInfo?.[0]?.last_name}` || "N/A")} size={"sm"}></Avatar>
              <ListText primary={`Hi, ${authInfo?.[0]?.first_name}`} secondary={`${authInfo?.[0]?.users?.user_type.charAt(0).toUpperCase() + authInfo?.[0]?.users?.user_type.slice(1)
                } User`} />
              <Box ml={"5"}>
                <FabButton
                  color="primary"
                  icon={<IoIosArrowDown />}
                  size="xs"
                  variant="filled"
                />
              </Box>
            </ListItem>
          </List>

          <HeaderMenu ref={dropdownRef} isVisible={isMenuVisible}>
            {authInfo?.[0]?.users?.user_type === "single" ?

                <List
                  size="md"
                  color="primary"
                  hover="secondary"
                  gap="1rem"
                  separator
                >
                  <ListItem>
                    <Avatar
                      className={"avatarHover"}
                      size="sm"
                      color="primary"
                      initials={shortFormName(`${authInfo?.[0]?.first_name} ${authInfo?.[0]?.last_name}` || "N/A")}
                    />
                    <ListText primary={`${authInfo?.[0]?.first_name} ${authInfo?.[0]?.last_name}`} secondary={signinEmail} />
                  </ListItem>
                </List>
              :
              <HeaderUserList>
                <HeaderUserItem>
                  <Avatar
                    className={"avatarHover"}
                    size="sm"
                    color="secondary"
                    src="https://images.pexels.com/photos/35537/child-children-girl-happy.jpg?cs=srgb&dl=pexels-bess-hamiti-83687-35537.jpg&fm=jpg"
                  />
                  <Box>
                    <Typography color="primary" underline="hover" mb={"0"}>
                      Olivia Rhye
                    </Typography>
                    <Typography
                      color={"default"}
                      colorVariant={"light"}
                      variant={"body2"}
                      mb={"0"}
                    >
                      olivia@untitledui.com
                    </Typography>
                  </Box>
                </HeaderUserItem>
                <HeaderUserItem>
                  <Avatar
                    className={"avatarHover"}
                    size="sm"
                    color="secondary"
                    src="https://media.istockphoto.com/id/1325921802/photo/shot-of-a-little-boy-wearing-a-backpack-in-nature.jpg?s=612x612&w=0&k=20&c=vV_LV-Q-kAxyL6Aa8MO37yYdGtMijXe8v9HMgl60bFA="
                  />
                  <Box>
                    <Typography color="primary" underline="hover" mb={"0"}>
                      Olivia Rhye
                    </Typography>
                    <Typography
                      color={"default"}
                      colorVariant={"light"}
                      variant={"body2"}
                      mb={"0"}
                    >
                      olivia@untitledui.com
                    </Typography>
                  </Box>
                </HeaderUserItem>
                <HeaderUserItem>
                  <Avatar
                    className={"avatarHover"}
                    size="sm"
                    color="secondary"
                    src="https://st2.depositphotos.com/2751239/7758/i/450/depositphotos_77580680-stock-photo-beautiful-little-boy-in-daisy.jpg"
                  />
                  <Box>
                    <Typography color="primary" underline="hover" mb={"0"}>
                      Olivia Rhye
                    </Typography>
                    <Typography
                      color={"default"}
                      colorVariant={"light"}
                      variant={"body2"}
                      mb={"0"}
                    >
                      olivia@untitledui.com
                    </Typography>
                  </Box>
                </HeaderUserItem>
                <HeaderUserItem>
                  <Avatar
                    className={"avatarHover"}
                    size="sm"
                    color="secondary"
                    src="https://img.freepik.com/free-photo/portrait-little-boy-smiling_23-2148337096.jpg"
                  />
                  <Box>
                    <Typography color="primary" underline="hover" mb={"0"}>
                      Olivia Rhye
                    </Typography>
                    <Typography
                      color={"default"}
                      colorVariant={"light"}
                      variant={"body2"}
                      mb={"0"}
                    >
                      olivia@untitledui.com
                    </Typography>
                  </Box>
                </HeaderUserItem>
                <Button variant="contained" color="primary" block fullWidth>
                  View All Organization
                </Button>
              </HeaderUserList>
            }
            <List
              size={"md"}
              color={"default"}
              activeColor={"success"}
              Colorvariant={"dark"}
            >
              {menuItems.map((item, index) => (
                <ListItem
                  key={index}
                  // onClick={() => navigate(item.path)}
                  className={location.pathname === item.path ? "active" : ""}
                  onClick={() =>
                    item.onClick ? item.onClick() : navigate(item.path)
                  }
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
            </List>
          </HeaderMenu>
        </HeaderContainer>
      </HeaderLayout>
    </>
  );
}
